import { ArrowDown, ArrowUp, ArrowUpDown } from "lucide-react";
import { useSearchParams } from "react-router-dom";
import { TableHead } from "../ui/table";
import { WithIcon } from "../utils/with-icon";
import { ObjectListColumn } from "./types";

export function ObjectListTableHead<T>({ column }: { column: ObjectListColumn<T> }) {
    const [searchParams, setSearchParams] = useSearchParams();

    const performOrdering = (value: string | null) => {
        let _searchParams = new URLSearchParams(searchParams);
        if (value) {
            _searchParams.set("o", value);
        } else {
            _searchParams.delete("o");
        }

        if (_searchParams.toString() != searchParams.toString()) {
            setSearchParams(_searchParams);
        }
    };

    return (
        <TableHead>
            {column.orderingKey ? (
                <WithIcon
                    className="cursor-pointer"
                    onClick={() => {
                        if (column.orderingKey) {
                            const currentValue = searchParams.get("o");
                            if (currentValue == column.orderingKey) {
                                performOrdering(`-${column.orderingKey}`);
                            } else if (currentValue == `-${column.orderingKey}`) {
                                performOrdering(null);
                            } else {
                                performOrdering(column.orderingKey);
                            }
                        }
                    }}
                    icon={
                        [column.orderingKey, `-${column.orderingKey}`].includes(searchParams.get("o") ?? "") ? (searchParams.get("o") == `-${column.orderingKey}` ? ArrowDown : ArrowUp) : ArrowUpDown
                    }
                    trailing
                >
                    {column.name}
                </WithIcon>
            ) : (
                column.name
            )}
        </TableHead>
    );
}
